import RichText from '@/components/RichText'
import React from 'react'

import { cn } from '@/utilities/ui'
import { Width } from '../Width'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

/**
 * Figma Form 4097:111068 uses a `message` block in two typographic roles, both laid out
 * flush at x=0 across the full 704px form (358px on mobile) — no prose gutter, no 65ch
 * measure — hence `enableGutter={false}` plus an explicit `max-w-none`:
 *
 *   heading     4097:112285 / 4097:112293 — Body/bodyMdAlt: `font/size/base` 16,
 *               line-height bound to `font/size/lg`, weight 400 (`font/weight/regular`).
 *   disclaimer  4097:112299 — Body/bodyMd: same 16 / `font/size/lg`,
 *               weight 300 (`font/weight/light`).
 *
 * `.prose p` in globals.css is unlayered (18px / weight 300), so the overrides need `!`.
 */
export const Message: React.FC<{
  message: DefaultTypedEditorState
  messageRole?: 'heading' | 'disclaimer'
}> = ({ message, messageRole = 'heading' }) => {
  return (
    <Width className="my-12" width="100">
      {message && (
        <RichText
          className={cn(
            // `mx-0 w-full` cancels RichText's own `mx-auto`, which would otherwise
            // shrink-wrap and centre the block inside `Width`'s flex column.
            'mx-0 w-full max-w-none! [&_p]:text-body-md!',
            messageRole === 'disclaimer' ? '[&_p]:font-light!' : '[&_p]:font-normal!',
          )}
          data={message}
          enableGutter={false}
        />
      )}
    </Width>
  )
}
